import React, {
    ReactNode,
    createContext,
    useContext,
    useState
} from 'react';

interface DashboardFilterState {
    filter: {
        showPassed: boolean;
    showFailed: boolean;
    showMissing: boolean;
    showNumberOfUnresolvedIssues: boolean;
    showNumberOfResolvedIssues: boolean;
    };
    toggleFilter: (filter: keyof DashboardFilterState['filter']) => void;
}

const DashboardFilterContext = createContext<DashboardFilterState | undefined>(undefined);

export const DashboardFilterProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [filter, setFilter] = useState<DashboardFilterState["filter"]>({
        showPassed: true,
        showFailed: true,
        showMissing: true,
        showNumberOfUnresolvedIssues: true,
        showNumberOfResolvedIssues: true
    });

    const toggleFilter = (filter: keyof DashboardFilterState['filter']) => {
        setFilter((prev) => {
            return {
                ...prev,
                [filter]: !prev[filter]
            };
        });
    };

    return (
        <DashboardFilterContext.Provider value={{filter, toggleFilter}}>
            {children}
        </DashboardFilterContext.Provider>
    );
};

export const useDashboardFilter = (): DashboardFilterState => {
    const context = useContext(DashboardFilterContext);
    if (!context) {
        throw new Error('useDashboardFilter must be used within a DashboardFilterProvider');
    }
    return context;
};